export default __webpack_public_path__ + "static/media/6673.aa05c1ab.jpg";